export default __webpack_public_path__ + "static/media/directory-member-male.4bdac8fb.svg";